//@flow

// Vendors
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Helpers
import { selectAgencyLink } from '../../../reducers/agency/agencySelectors';
import useRedirect from '../../../hooks/useRedirect';
import { clearAlertInfo } from '../../../reducers/alert/alertActions';

// PRJ1417943 - Integration Accelerator - Dynamically load all agency LinkServiceConfirm components
const confirmContext = require.context(
  '../../../agencies',
  true,
  /link-service\/LinkServiceConfirm\.js$/
);
const agencyConfirmComponents = {};
confirmContext.keys().forEach(key => {
  // PRJ1417943 - Integration Accelerator - Extract agency slug from path, e.g. './DPS/link-service/LinkServiceConfirm.js' => 'dps'
  const match = key.match(/\.\/(.*?)\/link-service\/LinkServiceConfirm\.js$/);
  if (match) {
    const slug = match[1].toLowerCase();
    agencyConfirmComponents[slug] = confirmContext(key).default;
  }
});

const LinkServiceConfirm = () => {
  const link = useSelector(selectAgencyLink);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(clearAlertInfo());
  }, []);

  useRedirect(!link || !link.linkData, '/link');
  useRedirect(!!link && !!link.linkData.userKey, '/link/already-linked');

  if (!link || !link.agency) return <p>There is an error.</p>;
  const AgencyConfirm = agencyConfirmComponents[link.agency.agencySlug];
  if (AgencyConfirm) {
    return <AgencyConfirm {...link.linkData} />;
  }
  return <p>There is an error.</p>;
};

export default LinkServiceConfirm;
